import React, {useState, useEffect} from 'react';
import Modal from '@material-ui/core/Modal';
import Close from '@material-ui/icons/Close';
import {axiosInstance} from 'utils/auth.service';
import SuspenseSpinner from 'components/SuspenseSpinner';
import VodVideoPlayer from 'components/VodVideoPlayer';

import './ModalPlayerVod.scss';

const ModalPlayerVod = ({onClose, rental}) => {
  const [videoId, setVideoId] = useState(null);

  useEffect(() => {
    if (!rental?.id) return;

    axiosInstance.get(`/users/rentals/${rental.id}`).then(res => {
      if (res.data) {
        setVideoId(res.data.film.video_id);
      }
    });

    return () => {
      setVideoId(null);
    };
  }, [rental.id]);

  if (!videoId) return <SuspenseSpinner />;

  return (
    <Modal open onClose={onClose}>
      <div className="video-container">
        <Close className="video-close" onClick={() => onClose()} />
        <VodVideoPlayer video={videoId} />
      </div>
    </Modal>
  );
};

export default ModalPlayerVod;
